export enum LanguageEnum {
  ENGLISH = 0,
  PORTUGUESE = 1,
}
